import React from 'react';
import PropTypes from 'prop-types';

import { CDN_URL } from '../../constants';

const BookCard = ({ permalink, thumbnail, title }) => {
  if (!permalink || !thumbnail || !title) {
    return null;
  }

  return (
    <div className='book-card'>
      <a href={permalink} className='book-card__link' rel='noreferrer' target='_blank'>
        <div className='book-card__media'>
          <img src={`${CDN_URL}${thumbnail}`} alt={title} className='book-card__img' />
        </div>
        <div className='book-card__title'>{title}</div>
      </a>
    </div>
  );
};

BookCard.propTypes = {
  permalink: PropTypes.string,
  thumbnail: PropTypes.string,
  title: PropTypes.string,
};

export default BookCard;
